export interface SubheadingProps {
  text: string;
  textColor?: string;
  className?: string;
}

const Subheading = ({ text, textColor = "text-black", className }: SubheadingProps) => {
  return (
    <h2
      className={`xl:text-2xl 3xl:text-3xl capitalize font-condensedBoldItalic ${textColor} ${className}`}
    >
      {text}
    </h2>
  );
};

export default Subheading;
